import React, {Fragment} from 'react';
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'

import {addTriAngle, addCircle, addRect} from '../../actions/index';

const Shapes = (props) => {
    return (
      <Fragment>
        <button onClick={props.addCircle}>Add Circle</button>
        <button onClick={props.addTriAngle}>Add TriAngle</button>
        <button onClick={props.addRect}>Add Rectangle</button>
      </Fragment>);
        }

    function mapStateToProps(state) {
        return {
            videos: state.canvas.videos,
        }
    }

    function mapDispatchToProps(dispatch) {
        return bindActionCreators(
            {
                addTriAngle: addTriAngle,
                addCircle:addCircle,
                addRect, addRect
            },
            dispatch
        )
    }
    export default connect(mapStateToProps, mapDispatchToProps)(Shapes)
